import styled, { FlattenSimpleInterpolation, keyframes } from "styled-components";

interface IContainer{
  styleInline?: string | FlattenSimpleInterpolation;
}

export const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  width: 20rem;
  min-height: 8.5rem;
  background-color: var(--input-background-color);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 8px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  ${(props) => props.styleInline}
`;

export const Title = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    padding:  0.25rem 0.5rem 0.5rem 0.5rem;
    font-size: 1rem;
    color: var(--default-color-font);

    border-bottom: 1px solid var(--border-color);
    span:first-child{
      font-weight: bold;
    }
    span:last-child{
      font-size: 0.85rem;
    }
`;


export const Line = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.2rem;
    font-size: 0.9rem;

    color: var(--input-font-color);
`;

export const LineFCA = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
    padding: 0.2rem;
    font-size: 0.83rem;

    color: var(--orange);
    >svg{
        margin-right: 4px;
    }
`;


const slideUpWithFade = keyframes`
  0% {
    bottom: -8.5rem;
    opacity: 0;
  }
  100% {
    bottom: 1rem;
    opacity: 1;
  }
`;

export const FadedWithSlideDiv = styled.div<IContainer>`
    position: fixed; 
    bottom: 1rem; 
    left: calc(var(--sidebar-width) + 1rem);
    z-index: 10; 
    width: auto;
    animation: ${slideUpWithFade} 500ms ease;

    ${(props) => props.styleInline}
`;
